import { api } from "@repo/convex/api";
import type { Id } from "@repo/convex/dataModel";
import { useQuery } from "convex/react";
import type { AssistantAskUserRequestRuntime } from "../types";

export function usePendingAssistantAskUser({
  projectId,
  threadId,
}: {
  projectId: Id<"projects">;
  threadId: string | null;
}): AssistantAskUserRequestRuntime | null | undefined {
  return useQuery(
    api.claudia.getPendingAskUserForThread,
    threadId ? { projectId, threadId } : "skip"
  );
}
